import { api } from './client';

// ---------------------------------------------------------------------------
// Tipos (espelham app/schemas/admin_metrics.py)
// ---------------------------------------------------------------------------

export interface MetricasAtivacao {
  usuarios_ativos: number;
  usuarios_total: number;
  onboarding_completo: number;
  onboarding_pct: number;
  novos_periodo: number;
  aptos_peticionar: number;
  aptos_verificados: number;
}

export interface MetricasAssinaturas {
  trial_ativo: number;
  trial_expirado: number;
  cortesia_ativa: number;
  expirando_7d: number;
}

export interface MetricasUso {
  comunicacoes_ingestadas: number;
  comunicacoes_lidas_pct: number;
  peticoes_criadas: number;
  protocolos_realizados: number;
  protocolo_sucesso_pct: number;
}

export interface AdminMetricsOverview {
  periodo: string;
  ativacao: MetricasAtivacao;
  assinaturas: MetricasAssinaturas;
  uso: MetricasUso;
}

export type MetricsPeriodo = '7d' | '30d' | '90d' | 'total';

export async function getAdminMetricsOverview(periodo: MetricsPeriodo): Promise<AdminMetricsOverview> {
  const { data } = await api.get<AdminMetricsOverview>('/admin/metrics/overview', { params: { periodo } });
  return data;
}
